export const TRAINING_TIMES = [15, 30, 45, 60];
